import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var SessionIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M19 1a3 3 0 013 3v9a3 3 0 01-3 3h-4.85l4.596 5.349a1 1 0 01-.016 1.322l-.09.088a1 1 0 01-1.323-.017l-.088-.09L13 17.731v4.27a1 1 0 01-.883.993L12 23a1 1 0 01-.993-.883L11 22v-4.317L6.758 22.62a1 1 0 11-1.516-1.304L9.809 16H5a3 3 0 01-3-3V4a3 3 0 013-3h14zm1 6.034H4V13a1 1 0 001 1h14a1 1 0 001-1V7.034zM19 3H5a1 1 0 00-1 1v1.034h16V4a1 1 0 00-1-1z",
                        fillRule: "nonzero"
                    })
                })
            })
        ]
    });
};
SessionIcon.isCarinaIcon = true;
export default SessionIcon;
